import {GeoJsonLayer} from '@deck.gl/layers';
import * as turf from '@turf/turf'
import {hexToRgb} from '../../utils'

export const INIT_LINE_SETTINGS = {
  color: "#cb4335",
  opacity: 100,
  width: 20,
  cap_rounded: true,
  joint_rounded: true,
  show_points: false,
  show_distance: true
}

export const line_layer = (props) => {
  var coords = props.line_coords
  var data = turf.lineString(coords, {line_settings: props.line_settings, id: props.id})

  return(
    new GeoJsonLayer({
      id: props.id,
      data: data,
      getLineColor: object => [...hexToRgb(object.properties.line_settings.color), Math.round(255 * object.properties.line_settings.opacity / 100)],
      getLineWidth: object => object.properties.line_settings.width,
      lineCapRounded: props.line_settings.cap_rounded,
      lineJointRounded: props.line_settings.joint_rounded,
      lineWidthUnits: 'meters',
      lineWidthScale: 1,
      lineWidthMinPixels: 0,
      lineBillboard: false,
      pickable: true
    })
  )
}

export const line_distance_layer = (id, line_coords) => {
  const meters = line_coords.map((c, i) => {
    if (line_coords[i+1]){
      return(turf.distance(line_coords[i+1], c, {units: 'meters'}))
    } else {
      return(0)
    }
  }).reduce((dist, a) => dist + a, 0)

  const div = Math.round(meters / 1000)
  const rem = Math.round(meters % 1000)
  const text = div > 0 ? `${div}км ${rem}м` : `${rem}м`

  return(
    new GeoJsonLayer({
      id: id,
      data: turf.point(line_coords[line_coords.length - 1], {id: id}),
      pickable: true,
      pointType: "text",
      getText: o => text,
      getTextColor: o => [0, 0, 0, 255],
      getTextAngle: o => 0,
      getTextSize: o => 14,
      getTextAnchor: o => 'end',
      getTextAlignmentBaseline: o => 'center',
      textSizeUnits: 'pixels',
      textSizeScale: 1,
      textCharacterSet: [" ", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "к", "м"],
      textFontFamily: 'monospace',
      textFontWeight: 'normal',
      textMaxWidth: -1,
      textWordBreak: 'break-word',
      textBackground: true, // need for BackgroundColor
      textBackgroundPadding: [
        6, 4, 6, 4 // left, top, right, bottom
      ],
      getTextBackgroundColor: o => [255, 255, 255, 255],
      getTextBorderColor: o => [0, 0, 0, 255],
      getTextBorderWidth: o => 2,
      textOutlineColor: [0, 0, 0, 0],
      textOutlineWidth: 0,
      textFontSettings: {sdf: true} // need for Outline
    })
  )
}
